import { Layout } from "@/components/Layout";
import { Reports } from "@/components/Reports";
import { FireDamage } from "@/components/FireDamage";

export default function SegnalazioniPage() {
  return (
    <Layout>
      <Reports />
      <FireDamage />
    </Layout>
  );
}
